<template>
  <div class="container py-5" style="max-width: 400px">
    <h2 class="mb-4 text-center">Login</h2>
    <form @submit.prevent="login">
      <div class="mb-3">
        <label for="email" class="form-label">E-mail</label>
        <input type="email" v-model="email" class="form-control" id="email" required />
      </div>
      <div class="mb-3">
        <label for="senha" class="form-label">Senha</label>
        <input type="password" v-model="senha" class="form-control" id="senha" required />
      </div>
      <button type="submit" class="btn btn-primary w-100">Entrar</button>
    </form>
  
<router-link to="/esqueci-senha" class="d-block mt-3 text-center">
  Esqueci minha senha
</router-link>

  </div>
</template>

<script>
import api from '../services/api'; // <-- usa o arquivo api.js com baseURL correta
import auth from '../store/auth';
export default {
  name: "LoginVie",
  data() {
    return {
      email: "",
      senha: "",
    };
  },
  methods: {
async login() {
  try {
    const response = await api.post('login.php', {
      email: this.email,
      senha: this.senha,
    });

    const usuario = response.data;

    if (usuario && usuario.tipo) {
      auth.login(usuario); // ← atualiza store reativa
      this.$router.push('/dashboard');
    } else {
      alert('Credenciais inválidas ou tipo de usuário ausente.');
    }
  } catch (error) {
    alert(error.response?.data?.erro || 'Erro ao tentar fazer login.');
  }
}
  },
};
</script>